import Button from '@/components/Button';

/**
 * Delivery date selector component
 * @param {object} props
 * @param {Array<string>} props.deliveryOptions - Available delivery dates
 * @param {string} props.selectedDate - Currently selected date
 * @param {function} props.onDateSelect - Callback when date is selected
 */
const DeliveryDateSelector = ({ deliveryOptions, selectedDate, onDateSelect }) => {
	if (deliveryOptions.length === 0) {
		return null;
	}

	return (
		<div className="p-2 flex flex-col items-center shadow-lg rounded-lg bg-white md:flex-row md:justify-around md:mb-4">
			<h3 className="text-left text-sm">Date de livraison souhaitée:</h3>

			<div className="grid grid-cols-1 gap-2 md:gap-4 md:w-1/2 md:grid-cols-2">
				{deliveryOptions.length === 1 ? (
					<span className="capitalize text-xs md:text-sm col-span-2 font-bold">{deliveryOptions[0]}</span>
				) : (
					deliveryOptions.map((date, index) => (
						<Button
							key={date || index}
							text={`${date}`}
							type={'Button'}
							action="button"
							handleClick={() => onDateSelect(date)}
							disabled={selectedDate !== date}
							withTopMargin={false}
							extraClasses={`capitalize text-xs md:text-sm`}
						/>
					))
				)}
			</div>
		</div>
	);
};

export default DeliveryDateSelector;

